import React, { useState, useEffect } from "react";
import Loader from "../Loader";
import NoResult from "../NoResult";
import CustomizeTableview from "../TableViews/CustomizeTableview";
import PaginationBar from "../PaginationBar";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import PayNowModal from "./PayNowModal";
import PopUpModal from "../Modal";
import ViewPaymentProofModal from "./ViewPaymentProofModal";

const SellerPayments = ({ search, statusSearch, fromDate, toDate, sizeOfPages }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [noOfPages, setNoOfPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [toggle, refresh] = useState(false);
  const [payments, setPayments] = useState([]);
  const [totalPayments, setTotalPayments] = useState();
  const [orderBy, setOrderBy] = useState({ processed_at: "DESC" });
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentData, setPaymentData] = useState({});
  const [caretData, setCaretData] = useState(null);
  const [viewReceiptModal, setViewReceiptModal] = useState(false);
  const [receipt, setReceipt] = useState("");
  const fetchAllSellerPayments = useApi(api.fetchAllSellersPayments, { hasCatchError: true });

  const changePage = (page) => {
    setCurrentPage(page);
  };

  //searchParams
  useEffect(() => {
    if (searchParams.get("page")) {
      setCurrentPage(Number(searchParams.get("page")));
    }
  }, [currentPage, toggle, searchParams]);
  function getSellerPayments() {
    try {
      fetchAllSellerPayments
        .request({
          page: currentPage,
          size: sizeOfPages,
          search: search,
          status: statusSearch,
          fromDate: fromDate,
          toDate: toDate,
          orderBy: orderBy,
        })
        .then((data) => {
          setIsLoading(false);
          setTotalPayments(data?.data?.paginationData?.no_of_items);
          setPayments(data?.data?.paymentsData.map((item) => ({ id: item.group_id, ...item })));

          if (data?.data?.paginationData?.no_of_pages === 0) {
            if (searchParams.get("page")) {
              setNoOfPages(0);
              navigate("/delivery-for-you/seller-payments?page=0");
            }
          } else {
            setNoOfPages(data?.data?.paginationData?.no_of_pages);
            if (currentPage > data?.data?.paginationData?.no_of_pages) {
              setCurrentPage(data?.data?.paginationData?.no_of_pages);
              navigate("/delivery-for-you/seller-payments?page=" + data?.data?.paginationData?.no_of_pages);
            }
            if (searchParams.get("page") === "0") {
              setCurrentPage(1);
              navigate("/delivery-for-you/seller-payments?page=1");
            }
          }
        })
        .catch((err) => {
          const tempErr = err.response.data.error;

          if (tempErr.status === 404 && tempErr.message === "No Record Found") {
            setPayments([]);
            setIsLoading(false);
          }
        });
    } catch (err) {
      const tempErr = err.response.data.error;

      if (tempErr.status === 404 && tempErr.message === "No Record Found") {
        setPayments([]);
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    let timeout;
    setIsLoading(true);
    getSellerPayments();
    return () => {
      clearTimeout(timeout);
    };
  }, [search, fromDate, toDate, currentPage, noOfPages, sizeOfPages, statusSearch, toggle, orderBy]);
  useEffect(() => {
    if (currentPage === 1) {
      refresh((prev) => !prev);
    } else {
      changePage(1);
    }
  }, [fromDate, toDate, statusSearch]);
  const caret = async (orderId) => {
    const data = payments?.filter((item) => item.id === orderId);
    const { orders_details } = data[0];
    const caretData = orders_details.map((item) => ({
      id: item.id,
      order_id: item?.order_id,
      order_number: item.order_number,
      parent_order_amount: item.parent_order_amount,
      seller_price: item.seller_price,
      order_commission: item.order_commission,
      net_payable: item.net_payable,
      order_payment_method: item.order_payment_method,
      paid_at: item.paid_at,
      is_paid: item.is_paid,
      created_at: item.created_at,
      updated_at: item.updated_at,
      is_deleted: item.is_deleted,
    }));
    setCaretData(
      <>
        <CustomizeTableview data={caretData} actions={false} columnNotShow={["id", "is_deleted", "payment_proof", "payment_transaction_id"]} dateColumn={["created_at", "updated_at", "paid_at"]} />
      </>
    );
  };
  const handlePaymentModal = (value) => {
    setPaymentModal(true);
    setPaymentData(value);
  };
  const closePaymentModal = () => {
    setPaymentData({});
    setPaymentModal(false);
    refresh((prev) => !prev);
  };
  const view = (value) => {
    setReceipt(value?.payment_proof);
    setViewReceiptModal(true);
  };
  const closeReceiptModal = () => {
    setReceipt("");
    setViewReceiptModal(false);
    refresh((prev) => !prev);
  };
  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "50vh",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Loader />
        </div>
      ) : payments?.length === 0 ? (
        <NoResult />
      ) : (
        <>
          <CustomizeTableview
            data={payments}
            columnNotShow={["id", "is_deleted", "orders_details", "payment_status", "payment_proof"]}
            dateColumn={["created_at", "updated_at", "paid_at", "processed_at"]}
            sortColumn={["created_at", "updated_at", "paid_at"]}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            caret={caret}
            caretData={caretData}
            status={{
              column: ["payment_status"],
              getClassName: ({ payment_status }) => {
                if (payment_status === "Pending") {
                  return "text-warning";
                } else if (payment_status === "Settled") {
                  return "text-success";
                } else {
                  return "text-danger";
                }
              },
              format: ({ payment_status }) => {
                if (payment_status === "Pending") {
                  return "Pending";
                } else if (payment_status === "Settled") {
                  return "Settled";
                } else {
                  return "Declined";
                }
              },
            }}
            view={{
              action: view,
              isShow: (value) => {
                return value?.["payment_status"] === "Settled" && value?.["payment_status"] !== null;
              },
            }}
            actionButton={{
              column: ["payment_status"],
              label: (value) => {
                return value["payment_status"] === "Pending" && "Log Payment";
              },
              onClick: async (er, value) => {
                handlePaymentModal(value);
              },
              variant: "outline-primary",
              disabled: (value) => value["payment_status"] === "Settled" || value["payment_status"] === "Declined",
              isShow: (_, row) => {
                return row?.["payment_status"] !== "Settled" && row?.["payment_status"] !== "Declined";
              },
            }}
          />
          <Row className="mt-5 align-items-center">
            <Col className="d-none d-md-block" md="3" lg="3">
              <span className="text-secondary fs-6">{totalPayments} result(s)</span>
            </Col>
            <Col xs="12" md="6" lg="6">
              <PaginationBar currentPage={currentPage} noOfPages={noOfPages} changePage={changePage} />
            </Col>
            <Col className="d-md-none d-flex align-items-center mt-3" xs="6" lg="3">
              <span className="text-secondary fs-6">{totalPayments} result(s)</span>
            </Col>
          </Row>
        </>
      )}
      <PopUpModal size="lg" title="Log Payment" show={paymentModal} onHide={closePaymentModal}>
        <PayNowModal toggle={toggle} close={closePaymentModal} data={paymentData} />
      </PopUpModal>
      <PopUpModal size="xl" title="Payment Proof" show={viewReceiptModal} onHide={closeReceiptModal}>
        <ViewPaymentProofModal data={receipt} />
      </PopUpModal>
    </>
  );
};

export default SellerPayments;
